import React from "react";
import { FormField } from "../../molecules/FormField/FormField";
import { Button } from "../../atoms/Button/Button";
import { Spinner } from "../../atoms/Spinner/Spinner";
import { MdSearch } from "react-icons/md";

// 1. Definimos una interfaz base para la prop `data`.
// Esto asegura que cualquier objeto que se pase como `data` tendrá las propiedades que el componente necesita.
interface BaseSearchData {
  loading: boolean;
  formData: {
    value: string;
  };
}

// 2. Usamos un tipo genérico `T` que debe ser compatible con `BaseSearchData`.
// Esto le da flexibilidad al componente para recibir `data` con más propiedades sin perder el tipado.
interface SearchFormProps<T extends BaseSearchData> {
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubmit: () => void;
  textButton: string;
  data: T;
}

// 3. Hacemos el componente genérico y pasamos `data` en la desestructuración de las props.
export const SearchForm = <T extends BaseSearchData>({ handleChange, handleSubmit, textButton, data }: SearchFormProps<T>) => {
  return (
    <form className="w-full">
      {data.loading && <Spinner size="small" />}
      {!data.loading && (
        <>
          <FormField
            label="Celular"
            id="value"
            type="text"
            placeholder="Ingresa tu Celular"
            value={data.formData.value}
            name="value"
            onChange={handleChange}
          />

          <Button color="primary" type="button" onClick={handleSubmit}>
            <MdSearch className="inline mr-2" size={20} />
            {textButton}
          </Button>
        </>
      )}
    </form>
  );
};
